import React, { useState } from "react";
import CalcSmall from "../../PicesForPages/calc-small.jpg";
import MortgageCalculator from "../CalculatorAndChart/mortgageCalculator";
import AffordCalculator from "../CalculatorAndChart/affordCalculator";
import ConsolidationCalculatorDebt from "../CalculatorAndChart/consolidationCalculatorDebt";
import BuyDownCalculator from "../CalculatorAndChart/buyDownCalculator";

function AllCalculators() {
  const [activeCalculator, setActiveCalculator] = useState("affordability"); // default active calculator

  return (
    <div className="TodaysRatesCalculatorParent">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={CalcSmall}
          alt="RFamilyImage"
          className="background-video"
        />
        <div className="purchasetopBox">
          {/* The existing Purchase span */}
          <span>Calculators</span>
        </div>
      </div>
      <div className="TodaysRatesCalculatorButtons">
        <button
          className={activeCalculator === "affordability" ? "active" : ""}
          onClick={() => setActiveCalculator("affordability")}
        >
          Affordability
        </button>
        <button
          className={activeCalculator === "monthlyPayment" ? "active" : ""}
          onClick={() => setActiveCalculator("monthlyPayment")}
        >
          Monthly Payment
        </button>
        <button
          className={activeCalculator === "buydown" ? "active" : ""}
          onClick={() => setActiveCalculator("buydown")}
        >
          Buy-Down
        </button>

        <button
          className={activeCalculator === "debtConsolidation" ? "active" : ""}
          onClick={() => setActiveCalculator("debtConsolidation")}
        >
          Debt Consolidation
        </button>
      </div>

      {/* Show only the active calculator */}
      {activeCalculator === "affordability" && <AffordCalculator />}
      {activeCalculator === "monthlyPayment" && <MortgageCalculator />}
      {activeCalculator === "buydown" && <BuyDownCalculator />}
      {activeCalculator === "debtConsolidation" && (
        <ConsolidationCalculatorDebt />
      )}
    </div>
  );
}

export default AllCalculators;
